



























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { sortByNumber, sortByString } from '@/utils/sort'
import { ElTable } from 'element-ui/types/table'
import { IZipListItem } from '@/api/types-fip'

@Component({
  name: 'EditZipRadiusTable'
})
export default class extends Vue {
  @Prop({
    type: Array,
    required: true,
    default: () => {
      return []
    }
  })
  list!: Array<IZipListItem>;

  @Prop({ type: Boolean })
  private _listLoading = false

  private showDeleteButton = 0

  public get listLoading() {
    return this._listLoading
  }

  public set listLoading(value) {
    this._listLoading = value
  }

  get isLoading(): boolean {
    return this._listLoading === true
  }

  sortState(a: IZipListItem, b: IZipListItem): number {
    return sortByString(a.state, b.state)
  }

  sortCounty(a: IZipListItem, b: IZipListItem): number {
    return sortByString(a.countyName, b.countyName)
  }

  sortCity(a: IZipListItem, b: IZipListItem): number {
    return sortByString(a.city, b.city)
  }

  sortPostalCode(a: IZipListItem, b: IZipListItem): number {
    return sortByNumber(a.zip, b.zip)
  }

  sortDistance(a: IZipListItem, b: IZipListItem): number {
    return sortByNumber(a.distance, b.distance)
  }

  selectedIds: number[] = []

  handleSelectionChange(rows: IZipListItem[]) {
    console.log(`${rows.length} Rows selected `)
    this.showDeleteButton = rows.length
    this.selectedIds = []
    if (rows) {
      rows.forEach(row => {
        if (row) {
          this.selectedIds.push(row.zip)
        }
      })
    }
  }

  handleDeleteSelected() {
    if (this.selectedIds) {
      this.$emit('handleDeleteMultiple', this.selectedIds)
      this.selectedIds = []
      const zipRadiusTable = this.$refs.zipRadiusTable as ElTable
      zipRadiusTable.clearSelection()
    }
  }
}
